import { render, staticRenderFns } from "./ReportPageHeader.vue?vue&type=template&id=0b526c8e&scoped=true&"
import script from "./ReportPageHeader.vue?vue&type=script&lang=js&"
export * from "./ReportPageHeader.vue?vue&type=script&lang=js&"
import style0 from "./ReportPageHeader.vue?vue&type=style&index=0&id=0b526c8e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b526c8e",
  null
  
)

export default component.exports